import t from "./translations";

export const SELECTED_PROJECTS_STORAGE_KEY =
  "lidarUploadStatus.selectedProjects";

export const LIDAR_UPLOAD_STATUSES = [
  "none",
  "raw_uploaded",
  "merged",
  "displayed",
  "analysed",
] as const;

export type LidarUploadStatusStep = (typeof LIDAR_UPLOAD_STATUSES)[number];

export const STALLED_AFTER_DAYS = 7;

export const STALLABLE_STATUSES: readonly LidarUploadStatusStep[] = [
  "raw_uploaded",
  "merged",
  "displayed",
];

export const STALLED_COLOR = "#FFB800";

export const STATUS_STEPS: Record<
  LidarUploadStatusStep,
  { label: string; color: string; textColor: string }
> = {
  none: { label: t.StatusNone, color: "#7C7C7C", textColor: "#FFFFFF" },
  raw_uploaded: {
    label: t.StatusRawUploaded,
    color: "#90CAF9",
    textColor: "#040404",
  },
  merged: { label: t.StatusMerged, color: "#42A5F5", textColor: "#040404" },
  displayed: {
    label: t.StatusDisplayed,
    color: "#1976D2",
    textColor: "#FFFFFF",
  },
  analysed: {
    label: t.StatusAnalysed,
    color: "#0D47A1",
    textColor: "#FFFFFF",
  },
};

export const AIRPELAGO_UPLOAD_STEP = {
  label: t.StatusAirpelagoUpload,
  color: "#7E57C2",
  textColor: "#FFFFFF",
};
